import { motion, useReducedMotion } from "framer-motion";
import { LANDING_COPY } from "@/data/landingContent";

export const LiveTranslatorBand = () => {
  const reduce = useReducedMotion();

  return (
    <section id="tradutor" className="container mx-auto scroll-mt-24 px-5 pb-6 md:px-8">
      <motion.div
        className="landing-card overflow-hidden rounded-[24px] border border-neutral-200 bg-white px-6 py-8 md:grid md:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] md:items-center md:gap-12 md:px-10 md:py-12"
        initial={reduce ? false : { opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.5 }}
      >
        <div>
          <p className="text-overline uppercase text-neutral-500">
            {LANDING_COPY.liveEyebrow}
          </p>
          <h2 className="mt-3 max-w-xl text-h1 md:text-display">
            {LANDING_COPY.liveTitle}
          </h2>
          <p className="mt-3 max-w-xl text-body text-neutral-500">
            {LANDING_COPY.liveBody}
          </p>
        </div>
        <div className="mt-8 space-y-3 md:mt-0" aria-hidden="true">
          <div className="rounded-2xl bg-blue-500 px-4 py-3 text-sm text-white">
            Window or aisle?
          </div>
          <div className="ml-8 rounded-2xl bg-neutral-100 px-4 py-3 text-sm text-neutral-900">
            Janela ou corredor?
          </div>
          <div className="rounded-2xl bg-orange-600 px-4 py-3 text-sm text-white">
            Aisle, please.
          </div>
          <div className="ml-8 rounded-2xl bg-neutral-100 px-4 py-3 text-sm text-neutral-900">
            Corredor, por favor.
          </div>
        </div>
      </motion.div>
    </section>
  );
};
